import { useTranslation } from 'react-i18next';
import { IoIosUnlock, IoMdSettings } from 'react-icons/io';

const PremiumBtn = ({ premiumUser = false }) => {
  const { t } = useTranslation();
  return (
    <a
      className={`premium-btn ${premiumUser ? 'subscribed' : ''}`}
      href={
        premiumUser
          ? 'https://docs.google.com/forms/d/e/1FAIpQLSf9AeoBwU6-mkcMVhxFKvK4fS646k4MRx07UFWzUgqMKjdZ7g/viewform?usp=sharing&ouid=100831582690962977700'
          : 'https://donaronline.org/fonselp/membresia-plataforma-de-comunidad-fonselp'
      }
      target="_blank"
      role="button"
      rel="noreferrer"
    >
      {premiumUser ? <IoMdSettings /> : <IoIosUnlock />}
      <span className="d-none d-sm-inline">{premiumUser ? t('header.header_msg14') : t('header.header_msg11')}</span>
      <span className="d-inline d-sm-none">{premiumUser ? t('header.header_msg15') : t('header.header_msg12')}</span>
    </a>
  );
};

export default PremiumBtn;
